module.exports = __webpack_public_path__ + "img/env1.44e7df90.jpg";